export default __webpack_public_path__ + "static/media/dropdown-icon.0e2db060.svg";